module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "file_014"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("Wool")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Almost any fiber can be needled—your hair, your kitty’s hair, dog hair, mohair, llama, and alpaca fiber. I find that sheep’s wool is the absolute best thing to use for needle felting. Why? Because sheep are cute. No, not really. Wool fiber has scales on it. When you poke the felting needle into the wool, the barbs on the sides of the needle make contact with the scales on the wool and cause them to tangle together. In essence, that is felt-making. The more you poke, the more compact the wool fiber becomes. This is where the magic begins . . . .")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some types of wool fibers are better for needle felting than others. This has to do with the coarseness of the wool. Wool types are named for the sheep breed from which they came. In addition, wool fiber that has been overly processed (known as “top”) can be a bit more difficult to work with.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Romney wool lends itself well to needle felting. Romney is not too fine, not too coarse. Corriedale is the kind of wool most readily available in spinning stores and is also nice to use. Other wool types that do well for needle felting include Black Welsh Mountain, Border Leicester, Lincoln, Jacob, and Southdown.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Merino is not recommended for needle felting. The fibers are too fine and slippery. Conversely, merino is the best wool to use for wet felting.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b86d8ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_014.vue
// module id = 96
// module chunks = 0